// extracted by mini-css-extract-plugin
module.exports =  {"categories_list":"_21620d3522--categories_list--DPOSe","container--service":"_21620d3522--container--service--Hlywc"};